import { Property } from '../../types/property';

export const ALL_PHASES_VALUE = 'all-phases';

export interface PropertyPhaseOption {
  label: string;
  value: string;
}

export const getPropertyPhaseOptions = (
  properties: Property[],
  allPhasesLabel = 'All Phases',
): PropertyPhaseOption[] => {
  const phaseMap = new Map<number, string>();

  properties.forEach((property) => {
    property.phases?.forEach((phase) => {
      if (!phaseMap.has(phase.id)) {
        phaseMap.set(phase.id, phase.name);
      }
    });
  });

  if (!phaseMap.size) {
    return [];
  }

  return [
    { label: allPhasesLabel, value: ALL_PHASES_VALUE },
    ...Array.from(phaseMap.entries())
      .map(([id, name]) => ({ label: name, value: id.toString() }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  ];
};

export const filterPropertiesByPhase = (properties: Property[], selectedPhase: string): Property[] => {
  if (!selectedPhase || selectedPhase === ALL_PHASES_VALUE) {
    return properties;
  }

  return properties.filter((property) => property.phases?.some((phase) => phase.id.toString() === selectedPhase));
};
